const ConnectableResourcesRenderer = require("../common/ConnectableResourcesRenderer");
const Utils = require("../common/Utils");

/**
 * @extends {ConnectableResourcesRenderer}
 * @constructor
 */
function TunnelsRenderer() {
    ConnectableResourcesRenderer.call(this);
    const self = this;

    /**
     * @override
     */
    this.renderStandardIcon = function(resource) {
        const size = 80;
        const scale = size / 1024;

        let fillColor;
        if (resource.dyn_state === "Disabled") {
            fillColor = "#bbbbbb";
        } else {
            fillColor = "url(#rgrad" + this.getColorIndex(resource) + ")";
        }

        const $div = $("<div>");
        $div.append('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"' +
            ' width="' + size + 'px" height="' + size + 'px" viewBox="0 0 ' + size + " " + size + '" enable-background="new 0 0 ' + size + " " + size + '" xml:space="preserve">' +
                '<g transform="scale(' + scale + ')" fill="' + fillColor + '">' +
                    '<g transform="matrix(8.8658009,0,0,8.8700252,-157.81126,-131.76428)">' +
                        '<path class="st0" d="M120.4,126.3c0,0.3,0,0.6,0,0.9l-9.1-8.2l0.8-49.5c0-0.1,0-0.2,0-0.3c-2.6-15.4-10.9-25.4-25.5-30.3c-2.2-0.7-4.4-1.3-6.6-1.5c-0.9-0.1-2.3-0.2-4-0.2c-1.7,0-3.4,0.1-4.5,0.2c-1.5,0.1-2.9,0.5-4.5,0.9l-0.4,0.1c-14.6,3.9-25,15.6-27,30.7c-0.1,0.4-0.2,0.8-0.3,1.2l0,0.1l-0.8,48.7l-7.7,8.1c0-0.5,0-0.9,0-1.4c0-9.1,0-18.3-0.1-27.4H17.9c0,10.2,0.1,20.5,0.1,30.7c0,0.4,0.2,0.8,0.3,1.2c4.2,0,8.3,0,12.6,0c0-0.1,0-0.1,0-0.2l9-9.5h70.1l10.5,9.4c0,0.1,0,0.2,0,0.3c4.4,0,8.4,0,12.7,0c0-1.4,0-2.6,0-3.8c0-9.4,0.1-18.7,0.1-28.1h-12.8C120.4,107.6,120.4,116.9,120.4,126.3z"/>' + // eslint-disable-line max-len
                        '<path class="st0" d="M120.2,68.9h12.7c0-0.3,0-0.6,0-0.9c-0.1-1-0.2-2.1-0.3-3.1c-1.2-10.2-4.6-19-10.1-26.5l-9.6,9.1C117,53.7,119.6,61,120.2,68.9z"/>' +
                        '<path class="st0" d="M120.4,71.5c0,0.3,0,0.6,0,0.9c0.1,7.9,0.1,15.7,0.1,23.6h12.8c0-8.1,0-16.1-0.2-24.2c0-0.2,0-0.3,0-0.5h-12.7C120.4,71.4,120.4,71.5,120.4,71.5z"/>' +
                        '<path class="st0" d="M57.7,31.4l-4.1-12.2c-9.8,4-18.2,10.6-24.4,18.9l9.3,9.3C43.2,40.4,49.9,34.8,57.7,31.4z"/>' +
                        '<path class="st0" d="M83.3,28.3c2.7,0.5,5.3,1.2,7.8,2.1l3.7-12.2c-13.6-4.9-25.9-3-26.4-2.9c-4.1,0.5-8.2,1.5-12,2.8L60,30.4C67.2,27.7,75.2,26.8,83.3,28.3z"/>' +
                        '<path class="st0" d="M111.6,45.7l9.3-9.3c-5.2-6.4-12.1-11.7-20.5-15.8c-1-0.5-2.1-1-3.2-1.4l-4.1,12.1C100.6,34.4,107,39.4,111.6,45.7z"/>' +
                        '<path class="st0" d="M37.2,49.3l-9.6-9c-5.5,8.2-8.9,17.9-9.3,28.4c0,0.1,0,0.1,0,0.2H31C31.5,61.7,33.7,55.1,37.2,49.3z"/>' +
                        '<path class="st0" d="M30.9,73.7c0-0.5,0-1.1,0-1.6c0-0.2,0-0.5,0-0.7H18.2c-0.3,8.2-0.4,16.5-0.4,24.7h12.9C30.8,88.6,30.8,81.1,30.9,73.7z"/>' +
                    "</g>" +
                "</g>" +
            "</svg>");

        const state = self.getStateClass(resource);
        const iconClasses = ["ui-li-thumb", "connectionOverlay", state];
        const iconText = self.getResourceIconText(resource);

        $div.append($("<div>", {
            class : iconClasses.join(" "),
            text : iconText,
            style : "font-size: " + Math.min(44, 60.0 / iconText.length) + "px"
        }));
        return $div;
    };
}

Utils.inherits(TunnelsRenderer, ConnectableResourcesRenderer);

module.exports = TunnelsRenderer;


//////////////////
// WEBPACK FOOTER
// ./tunnels/TunnelsRenderer.js
// module id = 120
// module chunks = 0